import { useMaterialStore } from '@/stores/material'
import { storeToRefs } from 'pinia'

export function useMaterialComposable() {
  const materialStore = useMaterialStore()
  const { currentItem } = storeToRefs(materialStore)

  const hasHelpText = (field: string) => {
    return !!materialStore.fields[field]?.help_text
  }

  return {
    materialStore,
    currentItem,
    hasHelpText
  }
}
